export default __webpack_public_path__ + "static/media/Settings_Line.1da9f56e.svg";